import React, { Suspense } from "react";

const JSONEditor = React.lazy(() => import("./json-editor").then(m => ({ default: m.JSONEditor })));

interface JSONEditorProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  minHeight?: string;
  height?: string;
  error?: boolean;
  errorLine?: number;
  className?: string;
  readOnly?: boolean;
}

export function JSONEditorLazy(props: JSONEditorProps) {
  return (
    <Suspense fallback={<div>Loading editor...</div>}>
      <JSONEditor {...props} />
    </Suspense>
  );
}